import {ErrorBoundary} from '@frontend/components/ErrorBoundary'
import {
    makeItemsListUrl,
    trans,
} from '@frontend/helpers'
import {
    useAdsStore,
    useUiLayoutStore,
} from '@frontend/stores'
import clsx from 'clsx'
import {useMemo} from 'react'
import {Link} from 'react-router-dom'
import {Collapse} from 'swayok-react-mdb-ui-kit/components/Collapse/Collapse'
import {Badge} from 'swayok-react-mdb-ui-kit/components/Typography/Badge'
import type {UILayout} from 'swayok-react-mdb-ui-kit/types/Common'
import type {AdCategory} from '../AdsModuleTypes'

interface Props {
    className?: string
}

// Максимальное количество отображаемых категорий.
const maxLimit: number = 12
// Максимальное количество отображаемых категорий для разных размеров экрана.
const limits: Record<UILayout['deviceType'], number> = {
    desktop: maxLimit,
    tablet: maxLimit,
    mobile: 8,
}

// Блок со списком популярных категорий верхнего уровня для главной.
export function PopularCategories(props: Props) {

    const {
        className,
    } = props

    const categories = useAdsStore(
        state => state.categories
    )
    const uiLayout = useUiLayoutStore()

    // Сортировка и выбор нужного количества категорий.
    const sortedCategories: AdCategory[] = useMemo(() => {
        const sorted: AdCategory[] = categories.slice()
        sorted.sort(
            (category1: AdCategory, category2: AdCategory): number => (
                (category2.adsCount ?? 0) - (category1.adsCount ?? 0)
            )
        )
        return sorted.slice(0, maxLimit)
    }, [categories])

    return (
        <ErrorBoundary
            silent
            inline
        >
            <Collapse show={sortedCategories.length > 0}>
                <section
                    className={clsx(
                        'popular-categories pb-3 pb-sm-4',
                        className
                    )}
                >
                    <h2 className="mb-2 mb-sm-4 fs-4">
                        {trans().ads.list.featured_categories}:
                    </h2>
                    <div className="d-grid grid-columns-2 grid-columns-md-2 grid-columns-lg-3 col-gap-3 row-gap-1 row-gap-sm-2">
                        {sortedCategories.slice(0, limits[uiLayout.deviceType]).map((category: AdCategory) => (
                            <div key={'category-' + String(category.id)}>
                                <Link
                                    className="d-sm-inline-flex flex-row align-items-center justify-content-start"
                                    to={makeItemsListUrl(category)}
                                >
                                    {category.name}
                                    {(uiLayout.bootstrapSize === 'xs' || uiLayout.bootstrapSize === 'xxs') ? (
                                        <span className="fs-8 fw-500 ms-1 popular-category-items-count text-primary">
                                            {category.adsCount ?? 0}
                                        </span>
                                    ) : (
                                        <Badge
                                            tag="span"
                                            color="gray"
                                            className="popular-category-items-count ms-2"
                                        >
                                            {category.adsCount ?? 0}
                                        </Badge>
                                    )}
                                </Link>
                            </div>
                        ))}
                    </div>
                </section>
            </Collapse>
        </ErrorBoundary>
    )
}
